import React from "react";
import { LightConfig } from "../LightConfig";
import { DirectionalLight } from "./DirectionalLight";
import { PointLight } from "./PointLight";
import { SpotLight } from "./SpotLight";

type LightProps = {
    config: LightConfig;
    drawHelpers?: boolean;
};

export const Light: React.FC<LightProps> = ({ config, drawHelpers = false }) => {
    if (config.type === "point") {
        return <PointLight config={config} drawHelpers={drawHelpers} />;
    }

    if (config.type === "directional") {
        return <DirectionalLight config={config} drawHelpers={drawHelpers} />;
    }

    if (config.type === "spot") {
        return <SpotLight config={config} drawHelpers={drawHelpers} />;
    }

    return (
        <ambientLight
            intensity={config.intensity}
            position={config.position}
            color={config.color}
        />
    );
};
